(function() {
	'use strict';

	angular
		.module('app.setup')
		.controller('projectGeneralSettings', projectGeneralSettings);

	projectGeneralSettings.$inject = ['$rootScope', '$scope', '$timeout', 'factorySettingService', 'storeService'];

	function projectGeneralSettings($rootScope, $scope, $timeout, factorySettingService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var backupValues = {};

		vm.isSuperAdmin = globalConfig.user.profileType === 'SuperSystemAdministrator';
		vm.saveSettings = saveSettings;
		vm.resetValues = resetValues;
		vm.disableReset = disableReset;
		vm.disableSave = disableSave;
		vm.saveProjectGeneralSettings = saveProjectGeneralSettings;
		vm.reviewFrequencyTooltipText = 'This setting impacts the time frame to display tasks in the A3 boxes for "Current Activity," "Accomplishments in the Last \'x\' Days," and "Tasks to be Started in \'x\' Days".';

		init();

		function init() {
			factorySettingService.getFactorySettings([
				'REVIEW_FREQUENCY_FOR_LEAN_INITIATIVES'
			], adminConfig.factory.id)
			.then(function initReviewFrequency(settings) {
				vm.reviewFrequency = parseInt(settings.REVIEW_FREQUENCY_FOR_LEAN_INITIATIVES);
				backupValues.reviewFrequency = vm.reviewFrequency;
			});
		}

		function saveSettings() {
			factorySettingService.saveFactorySettings({
				REVIEW_FREQUENCY_FOR_LEAN_INITIATIVES: vm.reviewFrequency
			}, adminConfig.factory.id).then(function (response) {
				if (response === 'Settings saved successfully') {
					backupValues.reviewFrequency = vm.reviewFrequency;

					$rootScope.$emit('toast', {
						'message': response,
						'success': true
					});
				} else {
					$rootScope.$emit('toast', {
						'message': response,
						'success': false
					});
				}
			});
		}

		function resetValues() {
			vm.reviewFrequency = backupValues.reviewFrequency;
		}

		function disableReset() {
			return vm.reviewFrequency == backupValues.reviewFrequency;
		}

		function disableSave() {
			return !vm.reviewFrequency ||
				Math.floor(vm.reviewFrequency) !== vm.reviewFrequency ||
				vm.reviewFrequency <= 0;
		}

		function saveProjectGeneralSettings() { 
			saveSettings();
		}
	}
})();
